/*
 * 
 * Backpack - Skyscanner's Design System
 * 
 * Copyright 2016-2021 Skyscanner Ltd
 * 
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *   http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * 
 */
export const privateBadgeBackgroundNormalDay = "rgb(239, 243, 248)";
export const privateBadgeBackgroundNormalNight = "rgb(36, 51, 70)";
export const canvasDay = "rgb(255, 255, 255)";
export const canvasNight = "rgb(1, 9, 19)";
export const canvasContrastDay = "rgb(239, 243, 248)";
export const canvasContrastNight = "rgb(1, 9, 19)";
export const coreEcoDay = "rgb(15, 161, 169)";
export const coreEcoNight = "rgb(15, 161, 169)";
export const coreAccentDay = "rgb(0, 98, 227)";
export const coreAccentNight = "rgb(132, 233, 255)";
export const corePrimaryDay = "rgb(5, 32, 60)";
export const corePrimaryNight = "rgb(5, 65, 132)";
export const statusSuccessSpotNight = "rgb(98, 241, 198)";
export const statusSuccessFillNight = "rgb(177, 255, 231)";
export const statusSuccessSpotDay = "rgb(12, 131, 138)";
export const statusSuccessFillDay = "rgb(212, 255, 242)";
export const statusDangerSpotNight = "rgb(255, 100, 156)";
export const statusWarningSpotNight = "rgb(254, 235, 135)";
export const statusDangerFillNight = "rgb(255, 202, 221)";
export const statusWarningFillNight = "rgb(251, 241, 187)";
export const statusDangerSpotDay = "rgb(231, 8, 102)";
export const statusWarningSpotDay = "rgb(245, 93, 66)";
export const statusDangerFillDay = "rgb(255, 233, 249)";
export const statusWarningFillDay = "rgb(255, 247, 207)";
export const surfaceHeroNight = "rgb(1, 9, 19)";
export const surfaceTintNight = "rgba(255, 255, 255, 0.1)";
export const surfaceDefaultNight = "rgb(19, 29, 43)";
export const surfaceHeroDay = "rgb(0, 98, 227)";
export const surfaceTintDay = "rgba(255, 255, 255, 0.1)";
export const surfaceDefaultDay = "rgb(255, 255, 255)";
export const surfaceContrastNight = "rgb(1, 9, 19)";
export const surfaceContrastDay = "rgb(5, 32, 60)";
export const surfaceElevatedNight = "rgb(36, 51, 70)";
export const surfaceLowContrastNight = "rgb(36, 51, 70)";
export const surfaceSubtleNight = "rgb(36, 51, 70)";
export const surfaceElevatedDay = "rgb(255, 255, 255)";
export const surfaceHighlightNight = "rgb(36, 51, 70)";
export const surfaceLowContrastDay = "rgb(245, 247, 250)";
export const surfaceSubtleDay = "rgb(227, 240, 255)";
export const surfaceHighlightDay = "rgb(224, 228, 233)";
export const textOnDarkDay = "rgb(255, 255, 255)";
export const textOnLightNight = "rgb(1, 9, 19)";
export const textDisabledOnDarkDay = "rgba(255, 255, 255, 0.5)";
export const textOnLightDay = "rgb(22, 22, 22)";
export const textLinkNight = "rgb(132, 233, 255)";
export const textHeroNight = "rgb(1, 9, 19)";
export const textDisabledNight = "rgba(255, 255, 255, 0.2)";
export const textLinkDay = "rgb(0, 98, 227)";
export const textHeroDay = "rgb(0, 98, 227)";
export const textPrimaryNight = "rgb(255, 255, 255)";
export const textSuccessNight = "rgb(98, 241, 198)";
export const textDisabledDay = "rgba(0, 0, 0, 0.2)";
export const textPrimaryDay = "rgb(22, 22, 22)";
export const textSuccessDay = "rgb(12, 131, 138)";
export const textErrorNight = "rgb(255, 100, 156)";
export const textErrorDay = "rgb(231, 8, 102)";
export const textPrimaryInverseNight = "rgb(1, 9, 19)";
export const textSecondaryNight = "rgb(189, 196, 203)";
export const textOnDarkNight = "rgb(255, 255, 255)";
export const textPrimaryInverseDay = "rgb(255, 255, 255)";
export const textDisabledOnDarkNight = "rgba(255, 255, 255, 0.5)";
export const textSecondaryDay = "rgb(98, 105, 113)";
export const lineDay = "rgb(193, 199, 207)";
export const lineNight = "rgb(68, 80, 95)";
export const lineOnDarkDay = "rgba(255, 255, 255, 0.5)";
export const lineOnDarkNight = "rgb(68, 80, 95)";
export const scrimDay = "rgba(0, 0, 0, 0.7)";
export const scrimNight = "rgba(0, 0, 0, 0.7)";
export const overlayDay = "rgba(0, 0, 0, 0.2)";
export const overlayNight = "rgba(255, 255, 255, 0.8)";
export const privateInfoBannerDefaultDay = "rgb(239, 243, 248)";
export const privateInfoBannerOnContrastDay = "rgb(255, 255, 255)";
export const privateInfoBannerSuccessDay = "rgb(12, 131, 138)";
export const privateInfoBannerErrorNight = "rgb(255, 100, 156)";
export const privateInfoBannerInfoNight = "rgb(189, 196, 203)";
export const privateInfoBannerErrorDay = "rgb(231, 8, 102)";
export const privateInfoBannerInfoDay = "rgb(98, 105, 113)";
export const privateInfoBannerWarningNight = "rgb(254, 235, 135)";
export const privateInfoBannerWarningDay = "rgb(245, 93, 66)";
export const privateInfoBannerDefaultNight = "rgb(19, 29, 43)";
export const privateInfoBannerOnContrastNight = "rgb(19, 29, 43)";
export const privateInfoBannerSuccessNight = "rgb(98, 241, 198)";
export const marcommsBerry = "rgb(231, 8, 102)";
export const marcommsCharcoal = "rgb(22, 22, 22)";
export const marcommsOrange = "rgb(255, 123, 89)";
export const marcommsGrey40 = "rgb(98, 105, 113)";
export const marcommsBlueBright = "rgb(161, 238, 255)";
export const marcommsYellow = "rgb(254, 235, 135)";
export const marcommsGreenBright = "rgb(147, 255, 222)";
export const marcommsPink = "rgb(255, 163, 229)";
export const marcommsSkyBlue = "rgb(0, 98, 227)";
export const marcommsDarkSky = "rgb(5, 32, 60)";
export const marcommsPurple = "rgb(142, 71, 186)";
export const marcommsWhite = "rgb(255, 255, 255)";
export const marcommsYellowMuted = "rgb(255, 247, 207)";
export const marcommsPinkMuted = "rgb(255, 233, 249)";
export const marcommsGreenMuted = "rgb(212, 255, 242)";
export const marcommsBlueMuted = "rgb(217, 248, 255)";
export const marcommsEcoGreen = "rgb(15, 161, 169)";
export const privateChipOnDarkOnFillDay = "rgb(21, 70, 121)";
export const privateChipOnDarkOnDismissIconNight = "rgba(255, 255, 255, 0.5)";
export const privateChipOnDarkOnBackgroundNight = "rgb(5, 65, 132)";
export const privateChipOnDarkOnBackgroundDay = "rgb(255, 255, 255)";
export const privateChipOnDarkOnDismissIconDay = "rgb(98, 105, 113)";
export const privateChipOnDarkPressedStrokeNight = "rgb(5, 65, 132)";
export const privateChipOnDarkPressedStrokeDay = "rgb(255, 255, 255)";
export const privateChipDisabledBackgroundNight = "rgb(11, 18, 29)";
export const privateChipDisabledBackgroundDay = "rgb(224, 228, 233)";
export const privateChipOnDarkOnFillNight = "rgb(2, 77, 175)";
export const privateMapPreviousSelectionDay = "rgb(207, 228, 255)";
export const privateMapClusterPinNight = "rgb(255, 255, 255)";
export const privateMapClusterPinPreviousSelectionNight = "rgb(148, 195, 255)";
export const privateMapClusterPinDay = "rgb(5, 32, 60)";
export const privateMapClusterPinPreviousSelectionDay = "rgb(148, 195, 255)";
export const privateMapMarkerViewedForegroundNight = "rgba(0, 0, 0, 0.8)";
export const privateMapMarkerViewedForegroundDay = "rgba(255, 255, 255, 0.8)";
export const privateMapPoiPinNight = "rgb(142, 71, 186)";
export const privateMapPreviousSelectionNight = "rgb(207, 228, 255)";
export const privateMapPoiPinDay = "rgb(142, 71, 186)";
export const privateButtonSecondaryPressedBackgroundNight = "rgb(1, 9, 19)";
export const privateButtonLinkNormalForegroundNight = "rgb(132, 233, 255)";
export const privateButtonLinkOnDarkDisabledForegroundNight = "rgba(255, 255, 255, 0.2)";
export const privateButtonSecondaryNormalBackgroundNight = "rgb(36, 51, 70)";
export const privateButtonPrimaryOnLightPressedBackgroundDay = "rgb(21, 70, 121)";
export const privateButtonFeaturedNormalBackgroundDay = "rgb(0, 98, 227)";
export const privateButtonFeaturedPressedBackgroundNight = "rgb(209, 247, 255)";
export const privateButtonPrimaryOnLightNormalBackgroundNight = "rgb(2, 77, 175)";
export const privateButtonSecondaryPressedBackgroundDay = "rgb(193, 199, 207)";
export const privateButtonLinkNormalForegroundDay = "rgb(0, 98, 227)";
export const privateButtonPrimaryOnLightDisabledForegroundNight = "rgba(255, 255, 255, 0.2)";
export const privateButtonSecondaryOnDarkDisabledBackgroundNight = "rgb(11, 18, 29)";
export const privateButtonDestructiveNormalForegroundNight = "rgb(255, 100, 156)";
export const privateButtonLinkOnDarkDisabledForegroundDay = "rgba(255, 255, 255, 0.2)";
export const privateButtonSecondaryNormalBackgroundDay = "rgb(224, 228, 233)";
export const privateButtonPrimaryOnLightNormalBackgroundDay = "rgb(5, 32, 60)";
export const privateButtonPrimaryOnLightDisabledForegroundDay = "rgba(0, 0, 0, 0.2)";
export const privateButtonPrimaryOnDarkNormalBackgroundNight = "rgb(255, 255, 255)";
export const privateButtonFeaturedPressedBackgroundDay = "rgb(2, 77, 175)";
export const privateButtonPrimaryOnDarkDisabledForegroundNight = "rgba(255, 255, 255, 0.2)";
export const privateButtonSecondaryOnDarkDisabledBackgroundDay = "rgb(11, 18, 29)";
export const privateButtonSecondaryOnDarkPressedBackgroundNight = "rgba(255, 255, 255, 0.2)";
export const privateButtonDestructiveNormalForegroundDay = "rgb(231, 8, 102)";
export const privateButtonPrimaryOnDarkNormalBackgroundDay = "rgb(255, 255, 255)";
export const privateButtonPrimaryOnDarkDisabledForegroundDay = "rgba(0, 0, 0, 0.2)";
export const privateButtonLinkPressedForegroundNight = "rgb(209, 247, 255)";
export const privateButtonSecondaryOnDarkPressedBackgroundDay = "rgb(4, 24, 45)";
export const privateButtonPrimaryOnLightDisabledBackgroundNight = "rgb(11, 18, 29)";
export const privateButtonLinkPressedForegroundDay = "rgb(2, 77, 175)";
export const privateButtonDestructiveNormalBackgroundNight = "rgb(36, 51, 70)";
export const privateButtonPrimaryNormalBackgroundNight = "rgb(2, 77, 175)";
export const privateButtonDestructivePressedBackgroundNight = "rgb(255, 100, 156)";
export const privateButtonPrimaryPressedBackgroundNight = "rgb(5, 65, 132)";
export const privateButtonPrimaryOnLightDisabledBackgroundDay = "rgb(224, 228, 233)";
export const privateButtonPrimaryOnDarkDisabledBackgroundNight = "rgb(11, 18, 29)";
export const privateButtonPrimaryNormalBackgroundDay = "rgb(5, 32, 60)";
export const privateButtonDestructiveNormalBackgroundDay = "rgb(224, 228, 233)";
export const privateButtonLinkOnDarkPressedForegroundNight = "rgba(255, 255, 255, 0.5)";
export const privateButtonDestructivePressedBackgroundDay = "rgb(231, 8, 102)";
export const privateButtonPrimaryPressedBackgroundDay = "rgb(21, 70, 121)";
export const privateButtonPrimaryOnDarkDisabledBackgroundDay = "rgb(224, 228, 233)";
export const privateButtonLinkOnDarkNormalForegroundNight = "rgb(255, 255, 255)";
export const privateButtonDisabledBackgroundNight = "rgb(11, 18, 29)";
export const privateButtonSecondaryOnDarkNormalBackgroundNight = "rgba(255, 255, 255, 0.1)";
export const privateButtonSecondaryOnDarkDisabledForegroundNight = "rgba(255, 255, 255, 0.2)";
export const privateButtonLinkOnDarkPressedForegroundDay = "rgba(255, 255, 255, 0.5)";
export const privateButtonPrimaryOnDarkPressedBackgroundNight = "rgb(193, 199, 207)";
export const privateButtonLinkOnDarkNormalForegroundDay = "rgb(255, 255, 255)";
export const privateButtonDisabledBackgroundDay = "rgb(224, 228, 233)";
export const privateButtonSecondaryOnDarkNormalBackgroundDay = "rgba(255, 255, 255, 0.1)";
export const privateButtonSecondaryOnDarkDisabledForegroundDay = "rgba(255, 255, 255, 0.2)";
export const privateButtonPrimaryOnDarkPressedBackgroundDay = "rgb(193, 199, 207)";
export const privateButtonPrimaryOnLightPressedBackgroundNight = "rgb(5, 65, 132)";
export const privateButtonFeaturedNormalBackgroundNight = "rgb(132, 233, 255)";
export const privateBarTrackDefaultDay = "rgb(224, 228, 233)";
export const privateBarTrackDefaultNight = "rgb(36, 51, 70)";
export const privateBarTrackOnContrastDay = "rgb(255, 255, 255)";
export const privateBarTrackOnContrastNight = "rgb(36, 51, 70)";
export const privateSkeletonShimmerStartEndDay = "rgba(255, 255, 255, 0)";
export const privateSkeletonShimmerStartEndNight = "rgba(0, 0, 0, 0)";
export const privateSkeletonShimmerCenterDay = "rgba(255, 255, 255, 0.6)";
export const privateSkeletonShimmerCenterNight = "rgba(0, 0, 0, 0.2)";
export const privateSponsoredBannerBackgroundDay = "rgb(239, 243, 248)";
export const privateSponsoredBannerBackgroundNight = "rgb(36, 51, 70)";
export const privateNavigationTabHoverDay = "rgb(21, 70, 121)";
export const privateNavigationTabHoverNight = "rgb(209, 247, 255)";
export const privateNavigationTabOutlineDay = "rgb(193, 199, 207)";
export const privateNavigationTabOutlineNight = "rgb(255, 255, 255)";
export const privateNavigationTabOnDarkOutlineDay = "rgba(255, 255, 255, 0.2)";
export const privateNavigationTabOnDarkOutlineNight = "rgba(255, 255, 255, 0.2)";
export const privateNavigationTabSelectedDay = "rgb(2, 77, 175)";
export const privateNavigationTabSelectedNight = "rgb(5, 65, 132)";
export const privateCardButtonContainedFillDay = "rgba(255, 255, 255, 0.8)";
export const privateCardButtonContainedFillNight = "rgba(0, 0, 0, 0.8)";
export const privateSegmentedControlCanvasDefaultDay = "rgb(239, 243, 248)";
export const privateSegmentedControlCanvasDefaultNight = "rgb(19, 29, 43)";
export const privateSegmentedControlSurfaceContrastDay = "rgba(255, 255, 255, 0.1)";
export const privateSegmentedControlSurfaceContrastNight = "rgb(19, 29, 43)";
export const privateSegmentedControlSurfaceContrastOnDay = "rgb(2, 77, 175)";
export const privateSegmentedControlSurfaceContrastOnNight = "rgb(5, 65, 132)";
export const privatePageIndicatorButtonCarouselNormalBackgroundDay = "rgba(255, 255, 255, 0.5)";
export const privatePageIndicatorButtonCarouselNormalBackgroundNight = "rgba(255, 255, 255, 0.5)";
export const privatePageIndicatorButtonCarouselPressedBackgroundDay = "rgba(255, 255, 255, 0.8)";
export const privatePageIndicatorButtonCarouselPressedBackgroundNight = "rgba(255, 255, 255, 0.8)";
export const colorSkyBlueShade03 = "rgb(2, 18, 44)";
export const colorPrimaryGradientLight = "rgb(0, 98, 227)";
export const colorErfoud = "rgb(255, 181, 77)";
export const colorValensole = "rgb(165, 155, 200)";
export const colorMonteverde = "rgb(0, 166, 152)";
export const backgroundElevation03DarkColor = "rgb(58, 58, 60)";
export const colorSkyGrayTint01 = "rgb(68, 69, 96)";
export const colorBlack = "rgb(1, 9, 19)";
export const backgroundElevation02DarkColor = "rgb(44, 44, 46)";
export const colorSkyGrayTint02 = "rgb(104, 105, 127)";
export const lineDarkColor = "rgb(72, 72, 74)";
export const backgroundElevation01DarkColor = "rgb(29, 27, 32)";
export const colorSagano = "rgb(208, 238, 236)";
export const colorSkyGrayTint03 = "rgb(143, 144, 160)";
export const colorSkyGrayTint04 = "rgb(178, 178, 191)";
export const colorHarbour = "rgb(246, 221, 225)";
export const colorSkyGrayTint05 = "rgb(205, 205, 215)";
export const backgroundAlternativeSecondaryDarkColor = "rgb(29, 27, 32)";
export const colorSkyGrayTint06 = "rgb(221, 221, 229)";
export const textPrimaryDarkColor = "rgb(255, 255, 255)";
export const textQuaternaryDarkColor = "rgb(142, 142, 147)";
export const backgroundLightColor = "rgb(255, 255, 255)";
export const colorBlackTint01 = "rgb(29, 27, 32)";
export const colorSkyGrayTint07 = "rgb(241, 242, 248)";
export const colorBlackTint02 = "rgb(44, 44, 46)";
export const colorAbisko = "rgb(90, 72, 155)";
export const textQuaternaryLightColor = "rgb(143, 144, 160)";
export const backgroundDarkColor = "rgb(0, 0, 0)";
export const colorBlackTint03 = "rgb(58, 58, 60)";
export const textPrimaryLightColor = "rgb(17, 18, 54)";
export const colorBlackTint04 = "rgb(72, 72, 74)";
export const backgroundAlternativeSecondaryLightColor = "rgb(255, 255, 255)";
export const colorWhite = "rgb(255, 255, 255)";
export const colorBlackTint05 = "rgb(99, 99, 102)";
export const colorBlackTint06 = "rgb(142, 142, 147)";
export const colorPanjin = "rgb(209, 67, 91)";
export const colorSystemGreen = "rgb(0, 166, 152)";
export const colorKolkata = "rgb(255, 148, 0)";
export const colorGlencoe = "rgb(115, 206, 198)";
export const backgroundElevation01LightColor = "rgb(255, 255, 255)";
export const colorTochigi = "rgb(225, 221, 236)";
export const lineLightColor = "rgb(205, 205, 215)";
export const backgroundElevation02LightColor = "rgb(255, 255, 255)";
export const backgroundElevation03LightColor = "rgb(255, 255, 255)";
export const colorPetra = "rgb(255, 171, 149)";
export const colorSkyBlue = "rgb(0, 98, 227)";
export const textTertiaryDarkColor = "rgb(142, 142, 147)";
export const backgroundTertiaryDarkColor = "rgb(44, 44, 46)";
export const backgroundSecondaryDarkColor = "rgb(29, 27, 32)";
export const textSecondaryDarkColor = "rgb(178, 178, 191)";
export const backgroundAlternativeLightColor = "rgb(241, 242, 248)";
export const primaryDarkColor = "rgb(109, 159, 235)";
export const colorBagan = "rgb(255, 235, 208)";
export const colorHillier = "rgb(225, 139, 150)";
export const colorSkyBlueTint01 = "rgb(109, 159, 235)";
export const colorSkyBlueTint02 = "rgb(157, 192, 242)";
export const colorBunol = "rgb(255, 123, 89)";
export const colorSkyBlueTint03 = "rgb(205, 223, 248)";
export const colorSkyGray = "rgb(17, 18, 54)";
export const colorSystemRed = "rgb(209, 67, 91)";
export const textSecondaryLightColor = "rgb(104, 105, 127)";
export const backgroundAlternativeDarkColor = "rgb(0, 0, 0)";
export const primaryLightColor = "rgb(0, 98, 227)";
export const backgroundTertiaryLightColor = "rgb(255, 255, 255)";
export const colorNara = "rgb(255, 231, 224)";
export const colorSkyBlueShade01 = "rgb(8, 78, 178)";
export const backgroundSecondaryLightColor = "rgb(241, 242, 248)";
export const textTertiaryLightColor = "rgb(143, 144, 160)";
export const colorSkyBlueShade02 = "rgb(4, 39, 89)";
export const durationXs = "50ms";
export const durationSm = "200ms";
export const durationBase = "400ms";
export const borderSizeSm = "1px";
export const borderSizeLg = "2px";
export const borderRadiusFull = "100%";
export const borderRadiusXl = "2.5rem";
export const borderRadiusMd = ".75rem";
export const borderRadiusNavTabs = "1.125rem";
export const borderRadiusSm = ".5rem";
export const borderRadiusXs = ".25rem";
export const borderRadiusLg = "1.5rem";
export const borderSizeXl = "3px";
export const boxShadowSm = "0px 1px 3px 0px rgba(37,32,31,.3)";
export const boxShadowLg = "0px 4px 14px 0px rgba(37,32,31,.25)";
export const boxShadowXl = "0px 12px 50px 0px rgba(37,32,31,.25)";
export const breakpointQueryTabletOnly = "(min-width: 32.0625rem) and (max-width: 64rem)";
export const breakpointSmallTabletMargin = "1.5rem";
export const breakpointQuerySmallTablet = "(max-width: 48rem)";
export const breakpointSmallMobileMargin = "1rem";
export const breakpointQueryMobile = "(max-width: 32rem)";
export const breakpointQuerySmallTabletOnly = "(min-width: 32.0625rem) and (max-width: 48rem)";
export const breakpointSmallMobile = "22.4375rem";
export const breakpointQueryAboveMobile = "(min-width: 32.0625rem)";
export const breakpointQueryTablet = "(max-width: 64rem)";
export const breakpointSmallTablet = "48rem";
export const breakpointQueryAboveTablet = "(min-width: 64.0625rem)";
export const breakpointDesktop = "80rem";
export const breakpointMobile = "32rem";
export const breakpointTablet = "64rem";
export const breakpointQueryDesktopOnly = "(min-width: 64.0625rem) and (max-width: 80rem)";
export const breakpointQueryAboveDesktop = "(min-width: 80.0625rem)";
export const breakpointTabletMargin = "2rem";
export const breakpointMobileMargin = "1rem";
export const breakpointQuerySmallMobile = "(max-width: 22.4375rem)";
export const breakpointDesktopMargin = "3rem";
export const buttonHeight = "2.25rem";
export const buttonBorderRadius = ".5rem";
export const buttonLargeHeight = "3rem";
export const privateButtonLineHeight = "1.5rem";
export const privateCardButtonContainedColor = "rgba(255, 255, 255, 0.8)";
export const calendarDaySpacing = ".5rem";
export const calendarDaySize = "2.25rem";
export const cardBackgroundColor = "rgb(255, 255, 255)";
export const cardPadding = "1rem";
export const primaryGradient = "#0062E3";
export const flareHeightDesktop = "1.5rem";
export const flareHeightMobile = "1rem";
export const flareCornerRadius = "1.3125rem";
export const inputLargeHeight = "3rem";
export const inputBorder = "solid .0625rem #C1C7CF";
export const selectBorderRadius = ".5rem";
export const inputBackground = "#ffffff";
export const inputBorderWidth = ".0625rem";
export const labelDisabledColor = "rgba(0, 0, 0, 0.2)";
export const inputLargeBorderRadius = ".75rem";
export const inputBorderRadius = ".5rem";
export const selectDisabledBorderColor = "rgb(224, 228, 233)";
export const inputDisabledColor = "rgba(0, 0, 0, 0.2)";
export const inputPaddingX = ".5rem";
export const inputPaddingY = ".5rem";
export const selectBorderWidth = ".0625rem";
export const formValidationColor = "rgb(231, 8, 102)";
export const inputHeight = "2.25rem";
export const selectLargeBorderRadius = ".75rem";
export const inputDisabledBorderColor = "rgb(239, 243, 248)";
export const horizontalNavBarSelectedColor = "rgb(0, 98, 227)";
export const iconSizeSm = "1rem";
export const iconSizeLg = "1.5rem";
export const iconSizeXl = "2rem";
export const iconSizeXxl = "2.5rem";
export const iconSizeXxxl = "3rem";
export const modalBackgroundColor = "rgb(255, 255, 255)";
export const modalInitialOpacity = "0";
export const modalOpacity = "1";
export const modalMaxWidth = "32rem";
export const modalWideMaxWidth = "64rem";
export const modalContentPadding = "1rem";
export const bannerAlertHeaderExpandableHoverBackgroundColor = "rgb(239, 243, 248)";
export const bannerAlertHeaderExpandableActiveBackgroundColor = "rgb(239, 243, 248)";
export const bannerAlertPrimaryColor = "rgb(0, 98, 227)";
export const bannerAlertSuccessColor = "rgb(12, 131, 138)";
export const bannerAlertWarnColor = "rgb(245, 93, 66)";
export const bannerAlertErrorColor = "rgb(231, 8, 102)";
export const bannerAlertNeutralColor = "rgb(193, 199, 207)";
export const panelBorderColor = "rgb(193, 199, 207)";
export const privateSliderSelectedDay = "rgb(21, 70, 121)";
export const onePixelRem = ".0625rem";
export const spacingNone = "0";
export const spacingIconText = ".5rem";
export const fontWeightBook = "400";
export const lineHeightXlTight = "1.75rem";
export const lineHeightXxxxxl = "4rem";
export const lineHeightXxxl = "3rem";
export const lineHeightXl = "2rem";
export const fontSizeXl = "1.5rem";
export const fontFamilyLarken = "'Larken', sans-serif";
export const fontSizeXxxxxl = "4rem";
export const fontSizeXxxl = "2.5rem";
export const lineHeightSm = "1.25rem";
export const lineHeightLgTight = "1.5rem";
export const lineHeightLg = "1.75rem";
export const fontWeightBlack = "900";
export const lineHeightXs = "1rem";
export const fontSizeSm = ".875rem";
export const fontSizeXs = ".75rem";
export const letterSpacingTight = "-0.02em";
export const fontSizeLg = "1.25rem";
export const letterSpacingDisplay = "-0.05em";
export const letterSpacingHero = "-0.04em";
export const fontSizeRoot = "100%";
export const fontSize6Xl = "4.75rem";
export const fontFamilyBase = "'Skyscanner Relative', -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
export const fontWeightBold = "700";
export const fontColorBase = "rgb(22, 22, 22)";
export const lineHeightBaseTight = "1.25rem";
export const fontSize7Xl = "6rem";
export const lineHeight6Xl = "4.75rem";
export const fontSize8Xl = "7.5rem";
export const fontSizeXxl = "2rem";
export const fontSizeXxxxl = "3rem";
export const lineHeightBase = "1.5rem";
export const lineHeight7Xl = "6rem";
export const fontSizeBase = "1rem";
export const fontWeightLight = "300";
export const lineHeight8Xl = "7.5rem";
export const lineHeightXxl = "2.5rem";
export const lineHeightXxxxl = "3.5rem";
export const zindexAutosuggest = "900";
export const zindexPopover = "900";
export const zindexTooltip = "900";
export const zindexScrim = "1000";
export const zindexModal = "1100";
export const zindexDrawer = "1100";
export const animations = {
durationXs,
durationSm,
durationBase,
};
export const badgeColors = {
privateBadgeBackgroundNormalDay,
privateBadgeBackgroundNormalNight,
};
export const borders = {
borderSizeSm,
borderSizeLg,
borderSizeXl,
};
export const boxShadows = {
boxShadowSm,
boxShadowLg,
boxShadowXl,
};
export const breakpoints = {
breakpointQueryTabletOnly,
breakpointSmallTabletMargin,
breakpointQuerySmallTablet,
breakpointSmallMobileMargin,
breakpointQueryMobile,
breakpointQuerySmallTabletOnly,
breakpointSmallMobile,
breakpointQueryAboveMobile,
breakpointQueryTablet,
breakpointSmallTablet,
breakpointQueryAboveTablet,
breakpointDesktop,
breakpointMobile,
breakpointTablet,
breakpointQueryDesktopOnly,
breakpointQueryAboveDesktop,
breakpointTabletMargin,
breakpointMobileMargin,
breakpointQuerySmallMobile,
breakpointDesktopMargin,
};
export const buttonColors = {
privateButtonSecondaryPressedBackgroundNight,
privateButtonLinkNormalForegroundNight,
privateButtonLinkOnDarkDisabledForegroundNight,
privateButtonSecondaryNormalBackgroundNight,
privateButtonPrimaryOnLightPressedBackgroundDay,
privateButtonFeaturedNormalBackgroundDay,
privateButtonFeaturedPressedBackgroundNight,
privateButtonPrimaryOnLightNormalBackgroundNight,
privateButtonSecondaryPressedBackgroundDay,
privateButtonLinkNormalForegroundDay,
privateButtonPrimaryOnLightDisabledForegroundNight,
privateButtonSecondaryOnDarkDisabledBackgroundNight,
privateButtonDestructiveNormalForegroundNight,
privateButtonLinkOnDarkDisabledForegroundDay,
privateButtonSecondaryNormalBackgroundDay,
privateButtonPrimaryOnLightNormalBackgroundDay,
privateButtonPrimaryOnLightDisabledForegroundDay,
privateButtonPrimaryOnDarkNormalBackgroundNight,
privateButtonFeaturedPressedBackgroundDay,
privateButtonPrimaryOnDarkDisabledForegroundNight,
privateButtonSecondaryOnDarkDisabledBackgroundDay,
privateButtonSecondaryOnDarkPressedBackgroundNight,
privateButtonDestructiveNormalForegroundDay,
privateButtonPrimaryOnDarkNormalBackgroundDay,
privateButtonPrimaryOnDarkDisabledForegroundDay,
privateButtonLinkPressedForegroundNight,
privateButtonSecondaryOnDarkPressedBackgroundDay,
privateButtonPrimaryOnLightDisabledBackgroundNight,
privateButtonLinkPressedForegroundDay,
privateButtonDestructiveNormalBackgroundNight,
privateButtonPrimaryNormalBackgroundNight,
privateButtonDestructivePressedBackgroundNight,
privateButtonPrimaryPressedBackgroundNight,
privateButtonPrimaryOnLightDisabledBackgroundDay,
privateButtonPrimaryOnDarkDisabledBackgroundNight,
privateButtonPrimaryNormalBackgroundDay,
privateButtonDestructiveNormalBackgroundDay,
privateButtonLinkOnDarkPressedForegroundNight,
privateButtonDestructivePressedBackgroundDay,
privateButtonPrimaryPressedBackgroundDay,
privateButtonPrimaryOnDarkDisabledBackgroundDay,
privateButtonLinkOnDarkNormalForegroundNight,
privateButtonDisabledBackgroundNight,
privateButtonSecondaryOnDarkNormalBackgroundNight,
privateButtonSecondaryOnDarkDisabledForegroundNight,
privateButtonLinkOnDarkPressedForegroundDay,
privateButtonPrimaryOnDarkPressedBackgroundNight,
privateButtonLinkOnDarkNormalForegroundDay,
privateButtonDisabledBackgroundDay,
privateButtonSecondaryOnDarkNormalBackgroundDay,
privateButtonSecondaryOnDarkDisabledForegroundDay,
privateButtonPrimaryOnDarkPressedBackgroundDay,
privateButtonPrimaryOnLightPressedBackgroundNight,
privateButtonFeaturedNormalBackgroundNight,
};
export const buttons = {
buttonHeight,
buttonBorderRadius,
buttonLargeHeight,
privateButtonLineHeight,
privateCardButtonContainedColor,
};
export const calendar = {
calendarDaySpacing,
calendarDaySize,
};
export const canvasColors = {
canvasDay,
canvasNight,
canvasContrastDay,
canvasContrastNight,
};
export const cardButtonColors = {
privateCardButtonContainedFillDay,
privateCardButtonContainedFillNight,
};
export const cards = {
cardBackgroundColor,
cardPadding,
};
export const chipColors = {
privateChipOnDarkOnFillDay,
privateChipOnDarkOnDismissIconNight,
privateChipOnDarkOnBackgroundNight,
privateChipOnDarkOnBackgroundDay,
privateChipOnDarkOnDismissIconDay,
privateChipOnDarkPressedStrokeNight,
privateChipOnDarkPressedStrokeDay,
privateChipDisabledBackgroundNight,
privateChipDisabledBackgroundDay,
privateChipOnDarkOnFillNight,
};
export const colors = {
colorSkyBlueShade03,
colorPrimaryGradientLight,
colorErfoud,
colorValensole,
colorMonteverde,
colorSkyGrayTint01,
colorBlack,
colorSkyGrayTint02,
lineDarkColor,
colorSagano,
colorSkyGrayTint03,
colorSkyGrayTint04,
colorHarbour,
colorSkyGrayTint05,
backgroundAlternativeSecondaryDarkColor,
colorSkyGrayTint06,
backgroundLightColor,
colorBlackTint01,
colorSkyGrayTint07,
colorBlackTint02,
colorAbisko,
backgroundDarkColor,
colorBlackTint03,
colorBlackTint04,
backgroundAlternativeSecondaryLightColor,
colorWhite,
colorBlackTint05,
colorBlackTint06,
colorPanjin,
colorSystemGreen,
colorKolkata,
colorGlencoe,
colorTochigi,
lineLightColor,
colorPetra,
colorSkyBlue,
backgroundTertiaryDarkColor,
backgroundSecondaryDarkColor,
backgroundAlternativeLightColor,
primaryDarkColor,
colorBagan,
colorHillier,
colorSkyBlueTint01,
colorSkyBlueTint02,
colorBunol,
colorSkyBlueTint03,
colorSkyGray,
colorSystemRed,
backgroundAlternativeDarkColor,
primaryLightColor,
backgroundTertiaryLightColor,
colorNara,
colorSkyBlueShade01,
backgroundSecondaryLightColor,
colorSkyBlueShade02,
primaryGradient,
};
export const coreColors = {
coreEcoDay,
coreEcoNight,
coreAccentDay,
coreAccentNight,
corePrimaryDay,
corePrimaryNight,
};
export const flare = {
flareHeightDesktop,
flareHeightMobile,
flareCornerRadius,
};
export const fontWeights = {
fontWeightBook,
fontWeightBlack,
fontWeightBold,
fontWeightLight,
};
export const forms = {
inputLargeHeight,
inputBorder,
selectBorderRadius,
inputBackground,
inputBorderWidth,
labelDisabledColor,
inputLargeBorderRadius,
inputBorderRadius,
selectDisabledBorderColor,
inputDisabledColor,
inputPaddingX,
inputPaddingY,
selectBorderWidth,
formValidationColor,
inputHeight,
selectLargeBorderRadius,
inputDisabledBorderColor,
};
export const horizontalNav = {
horizontalNavBarSelectedColor,
};
export const icons = {
iconSizeSm,
iconSizeLg,
iconSizeXl,
iconSizeXxl,
iconSizeXxxl,
};
export const infoBannerColors = {
privateInfoBannerDefaultDay,
privateInfoBannerOnContrastDay,
privateInfoBannerSuccessDay,
privateInfoBannerErrorNight,
privateInfoBannerInfoNight,
privateInfoBannerErrorDay,
privateInfoBannerInfoDay,
privateInfoBannerWarningNight,
privateInfoBannerWarningDay,
privateInfoBannerDefaultNight,
privateInfoBannerOnContrastNight,
privateInfoBannerSuccessNight,
};
export const letterSpacings = {
letterSpacingTight,
letterSpacingDisplay,
letterSpacingHero,
};
export const lineColors = {
lineDay,
lineNight,
lineOnDarkDay,
lineOnDarkNight,
};
export const mapMarkerColors = {
privateMapPreviousSelectionDay,
privateMapClusterPinNight,
privateMapClusterPinPreviousSelectionNight,
privateMapClusterPinDay,
privateMapClusterPinPreviousSelectionDay,
privateMapMarkerViewedForegroundNight,
privateMapMarkerViewedForegroundDay,
privateMapPoiPinNight,
privateMapPreviousSelectionNight,
privateMapPoiPinDay,
};
export const marcommsColors = {
marcommsBerry,
marcommsCharcoal,
marcommsOrange,
marcommsGrey40,
marcommsBlueBright,
marcommsYellow,
marcommsGreenBright,
marcommsPink,
marcommsSkyBlue,
marcommsDarkSky,
marcommsPurple,
marcommsWhite,
marcommsYellowMuted,
marcommsPinkMuted,
marcommsGreenMuted,
marcommsBlueMuted,
marcommsEcoGreen,
};
export const modals = {
modalBackgroundColor,
modalInitialOpacity,
modalOpacity,
modalMaxWidth,
modalWideMaxWidth,
modalContentPadding,
};
export const navigationTabColors = {
privateNavigationTabHoverDay,
privateNavigationTabHoverNight,
privateNavigationTabOutlineDay,
privateNavigationTabOutlineNight,
privateNavigationTabOnDarkOutlineDay,
privateNavigationTabOnDarkOutlineNight,
privateNavigationTabSelectedDay,
privateNavigationTabSelectedNight,
};
export const notifications = {
bannerAlertHeaderExpandableHoverBackgroundColor,
bannerAlertHeaderExpandableActiveBackgroundColor,
bannerAlertPrimaryColor,
bannerAlertSuccessColor,
bannerAlertWarnColor,
bannerAlertErrorColor,
bannerAlertNeutralColor,
};
export const overlayColors = {
overlayDay,
overlayNight,
};
export const pageIndicatorColors = {
privatePageIndicatorButtonCarouselNormalBackgroundDay,
privatePageIndicatorButtonCarouselNormalBackgroundNight,
privatePageIndicatorButtonCarouselPressedBackgroundDay,
privatePageIndicatorButtonCarouselPressedBackgroundNight,
};
export const panels = {
panelBorderColor,
};
export const radii = {
borderRadiusFull,
borderRadiusXl,
borderRadiusMd,
borderRadiusNavTabs,
borderRadiusSm,
borderRadiusXs,
borderRadiusLg,
};
export const ratingBarColors = {
privateBarTrackDefaultDay,
privateBarTrackDefaultNight,
privateBarTrackOnContrastDay,
privateBarTrackOnContrastNight,
};
export const scrimColors = {
scrimDay,
scrimNight,
};
export const segmentedControlColors = {
privateSegmentedControlCanvasDefaultDay,
privateSegmentedControlCanvasDefaultNight,
privateSegmentedControlSurfaceContrastDay,
privateSegmentedControlSurfaceContrastNight,
privateSegmentedControlSurfaceContrastOnDay,
privateSegmentedControlSurfaceContrastOnNight,
};
export const skeletonColors = {
privateSkeletonShimmerStartEndDay,
privateSkeletonShimmerStartEndNight,
privateSkeletonShimmerCenterDay,
privateSkeletonShimmerCenterNight,
};
export const sliderColors = {
privateSliderSelectedDay,
};
export const spacings = {
onePixelRem,
spacingNone,
spacingIconText,
};
export const sponsoredBannerColors = {
privateSponsoredBannerBackgroundDay,
privateSponsoredBannerBackgroundNight,
};
export const statusColors = {
statusSuccessSpotNight,
statusSuccessFillNight,
statusSuccessSpotDay,
statusSuccessFillDay,
statusDangerSpotNight,
statusWarningSpotNight,
statusDangerFillNight,
statusWarningFillNight,
statusDangerSpotDay,
statusWarningSpotDay,
statusDangerFillDay,
statusWarningFillDay,
};
export const surfaceColors = {
surfaceHeroNight,
surfaceTintNight,
surfaceDefaultNight,
surfaceHeroDay,
surfaceTintDay,
surfaceDefaultDay,
surfaceContrastNight,
surfaceContrastDay,
surfaceElevatedNight,
surfaceLowContrastNight,
surfaceSubtleNight,
surfaceElevatedDay,
surfaceHighlightNight,
surfaceLowContrastDay,
surfaceSubtleDay,
surfaceHighlightDay,
};
export const textColors = {
textOnDarkDay,
textOnLightNight,
textDisabledOnDarkDay,
textOnLightDay,
textLinkNight,
textHeroNight,
textDisabledNight,
textLinkDay,
textHeroDay,
textPrimaryNight,
textSuccessNight,
textDisabledDay,
textPrimaryDay,
textSuccessDay,
textErrorNight,
textErrorDay,
textPrimaryInverseNight,
textSecondaryNight,
textOnDarkNight,
textPrimaryInverseDay,
textDisabledOnDarkNight,
textSecondaryDay,
backgroundElevation03DarkColor,
backgroundElevation02DarkColor,
backgroundElevation01DarkColor,
textPrimaryDarkColor,
textQuaternaryDarkColor,
textQuaternaryLightColor,
textPrimaryLightColor,
backgroundElevation01LightColor,
backgroundElevation02LightColor,
backgroundElevation03LightColor,
textTertiaryDarkColor,
textSecondaryDarkColor,
textSecondaryLightColor,
textTertiaryLightColor,
fontColorBase,
};
export const typesettings = {
lineHeightXlTight,
lineHeightXxxxxl,
lineHeightXxxl,
lineHeightXl,
fontSizeXl,
fontFamilyLarken,
fontSizeXxxxxl,
fontSizeXxxl,
lineHeightSm,
lineHeightLgTight,
lineHeightLg,
lineHeightXs,
fontSizeSm,
fontSizeXs,
fontSizeLg,
fontSizeRoot,
fontSize6Xl,
fontFamilyBase,
lineHeightBaseTight,
fontSize7Xl,
lineHeight6Xl,
fontSize8Xl,
fontSizeXxl,
fontSizeXxxxl,
lineHeightBase,
lineHeight7Xl,
fontSizeBase,
lineHeight8Xl,
lineHeightXxl,
lineHeightXxxxl,
};
export const zIndices = {
zindexAutosuggest,
zindexPopover,
zindexTooltip,
zindexScrim,
zindexModal,
zindexDrawer,
};